import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../../../App';

function authHeader(){ const t = localStorage.getItem('token'); return t ? { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }; }

export default function DashboardAdmin(){
  const { user } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const [loading, setLoading] = useState(false);
  const [counts, setCounts] = useState({ schools: 0, students: 0, teachers: 0, mods: 0, lessons: 0 });
  const [recentUsers, setRecentUsers] = useState([]);
  const [recentLessons, setRecentLessons] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [schools, setSchools] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [newSyName, setNewSyName] = useState('');
  const [newSyStart, setNewSyStart] = useState('');
  const [newSyEnd, setNewSyEnd] = useState('');
  const [newSyDefault, setNewSyDefault] = useState(false);
  const [creatingSy, setCreatingSy] = useState(false);
  const [createSyError, setCreateSyError] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [openSchoolId, setOpenSchoolId] = useState(null);

  // persist selected school for admin flows so Accounts page can pick it up
  useEffect(() => {
    try {
      if (selectedSchoolId) {
        localStorage.setItem('admin_selected_school', String(selectedSchoolId));
      } else {
        localStorage.removeItem('admin_selected_school');
      }
    } catch (e) { }
  }, [selectedSchoolId]);

  // close school actions dropdown when clicking outside
  useEffect(() => {
    const onDocClick = (e) => {
      try {
        if (!openSchoolId) return;
        const el = document.querySelector(`[data-school-actions-id="${openSchoolId}"]`);
        if (!el) return;
        if (!el.contains(e.target)) setOpenSchoolId(null);
      } catch (err) { /* ignore */ }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [openSchoolId]);

  useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      try {
        // fetch in parallel (include school-years)
        const [sRes, stRes, uRes, lRes, syRes] = await Promise.all([
          fetch(`${apiUrl}/api/admin/schools`, { headers: authHeader() }),
          fetch(`${apiUrl}/api/admin/students`, { headers: authHeader() }),
          fetch(`${apiUrl}/api/admin/users`, { headers: authHeader() }),
          fetch(`${apiUrl}/api/lessons`, { headers: authHeader() }),
          fetch(`${apiUrl}/api/admin/school-years`, { headers: authHeader() })
        ]);

  const sJ = sRes && sRes.ok ? await sRes.json() : { schools: [] };
  const stJ = stRes && stRes.ok ? await stRes.json() : { students: [] };
  const uJ = uRes && uRes.ok ? await uRes.json() : { users: [] };
  const lJ = lRes && lRes.ok ? await lRes.json() : { lessons: [] };
  const syJ = syRes && syRes.ok ? await syRes.json() : { schoolYears: [] };

  const users = uJ.users || [];
        const teachers = users.filter(u => u.role === 'Teacher').length;
        const mods = users.filter(u => u.role === 'Mod').length;

  // populate schools and cache users/students for local summarization
  setSchools((sJ && sJ.schools) ? sJ.schools : []);
  setAllUsers(users);
  setAllStudents((stJ && stJ.students) ? stJ.students : []);
        // if current user is a Mod, default to their assigned school (so quick actions operate in that school)
        try {
          if (user && (user.role || '').toLowerCase() === 'mod') {
            setSelectedSchoolId(user.school_id || null);
          }
        } catch (e) { }

        setCounts({
          schools: (sJ.schools || []).length,
          students: (stJ.students || []).length,
          teachers,
          mods,
          lessons: (lJ.lessons || []).length
        });
        // derive recent items for small preview panels (show up to 5)
        setRecentUsers((uJ.users || []).slice().sort((a,b)=> (Number(b.id)||0)-(Number(a.id)||0)).slice(0,5));
  setRecentLessons((lJ.lessons || []).slice().sort((a,b)=> (Number(b.id)||0)-(Number(a.id)||0)).slice(0,5));
  const syList = (syJ && syJ.schoolYears) ? syJ.schoolYears : [];
        setSchoolYears(syList);
        // expose for other admin pages that may run before fetch (legacy pages)
        try { window.__SCHOOL_YEARS__ = syList; } catch (e) { /* ignore */ }
        setLastUpdated(new Date());
      } catch (e) {
        console.error('Failed to load dashboard counts', e);
      }
      setLoading(false);
    })();
  }, [user]);

  return (
    <div className="admin-dashboard" style={{ height: '100%' }}>
      <h2>Dashboard</h2>
      <div style={{ marginTop: 12 }}>
        {loading ? <div className="muted">Loading summary…</div> : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', alignItems: 'start' }}>
            {/* Left: summary cards and recent lists */}
            <div>
              <div className="dashboard-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
                <Card title="Schools" value={counts.schools} color="#4CAF50" icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11l9-6 9 6-9 6-9-6z"/><path d="M12 21V11"/></svg>} onClick={() => window.location.href = '/admin/accounts'} />
                <Card title="Students" value={counts.students} color="#2196F3" icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="4"/><path d="M5.5 21a7.5 7.5 0 0 1 13 0"/></svg>} onClick={() => window.location.href = '/admin/accounts?tab=students'} />
                <Card title="Teachers" value={counts.teachers} color="#FF9800" icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>} onClick={() => window.location.href = '/admin/accounts?tab=teachers'} />
                <Card title="Mods" value={counts.mods} color="#9C27B0" icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 12v.01"/><path d="M21 12a9 9 0 1 0-9 9"/></svg>} onClick={() => window.location.href = '/admin/accounts?tab=mods'} />
                <Card title="Lessons" value={counts.lessons} color="#607D8B" icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M7 21h10"/></svg>} onClick={() => window.location.href = '/admin/lessons'} />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginTop: 16 }}>
                <Panel title="Recent users" hint={recentUsers.length ? `Updated ${recentUsers.length} items` : ''}>
                  {recentUsers.length === 0 ? <div className="muted">No recent users</div> : (
                    <ul className="compact-list">
                      {recentUsers.map(u => (<li key={u.id}><strong>{u.username}</strong> <span className="muted">{u.full_name || u.identifier_code || ''}</span></li>))}
                    </ul>
                  )}
                </Panel>
                
                {/* <Panel title="School years">
                  <div style={{ marginTop: 8 }}>
                    <div className="muted">Manage school years on a dedicated page.</div>
                    <div style={{ marginTop: 8 }}>
                      <button onClick={() => { window.location.href = '/admin/school-years'; }}>Open School years manager</button>
                    </div>
                  </div>
                </Panel> */}
                <Panel title="Recent lessons">
                  {recentLessons.length === 0 ? <div className="muted">No recent lessons</div> : (
                    <ul className="compact-list">
                      {recentLessons.map(l => (<li key={l.id}><strong>{l.title || ('#' + l.id)}</strong> <span className="muted">{l.grade || ''}</span></li>))}
                    </ul>
                  )}
                </Panel>

                {/* Move School summary here as the third column */}
                <Panel title="School summary">
                  <div style={{ marginTop: 8 }}>
                    {(schools && schools.length) ? (
                      <ul className="compact-list">
                        {(schools || []).map(s => {
                          const sid = Number(s.id);
                          const studentCount = (allStudents || []).filter(st => Number(st.school_id) === sid).length;
                          const teacherCount = (allUsers || []).filter(u => u.role === 'Teacher' && Number(u.school_id) === sid).length;
                          const modCount = (allUsers || []).filter(u => u.role === 'Mod' && Number(u.school_id) === sid).length;
                          const isAssigned = user && user.school_id && Number(user.school_id) === sid;
                          return (
                            <li key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <strong>{s.school_name || s.name || `School ${s.id}`}</strong>
                                <div className="muted" style={{ fontSize: 12 }}>{studentCount} students · {teacherCount} teachers · {modCount} mods{isAssigned ? ' · (Your school)' : ''}</div>
                              </div>
                              <div className="school-actions" data-school-actions-id={sid} style={{ position: 'relative' }}>
                                <button className="school-actions-toggle" aria-haspopup="true" aria-expanded={openSchoolId === sid} title="Actions" onClick={(e) => { e.stopPropagation(); setOpenSchoolId(openSchoolId === sid ? null : sid); }}>
                                  ⋯
                                </button>
                                {openSchoolId === sid && (
                                  <div className="school-actions-menu" role="menu">
                                    <button role="menuitem" onClick={() => { try { localStorage.setItem('admin_selected_school', String(sid)); } catch (e) {} setOpenSchoolId(null); window.location.href = '/admin/accounts?tab=students'; }}>View students</button>
                                    <button role="menuitem" onClick={() => { try { localStorage.setItem('admin_selected_school', String(sid)); } catch (e) {} setOpenSchoolId(null); window.location.href = '/admin/accounts?tab=teachers'; }}>View teachers</button>
                                    <button role="menuitem" onClick={() => { try { localStorage.setItem('admin_selected_school', String(sid)); } catch (e) {} setOpenSchoolId(null); window.location.href = '/admin/accounts?tab=classes'; }}>View classes</button>
                                  </div>
                                )}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div className="muted">No schools available</div>
                    )}
                  </div>
                </Panel>
              </div>

              <div style={{ marginTop: 12, color: '#666', fontSize: 13 }}>
                {lastUpdated ? `Last refreshed: ${new Date(lastUpdated).toLocaleString()}` : 'Not refreshed yet'}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// small count tween animator
function CountAnim({ value = 0, duration = 700 }) {
  const refPrev = useRef(Number(value) || 0);
  const [display, setDisplay] = useState(Number(value) || 0);

  useEffect(() => {
    const start = Number(refPrev.current) || 0;
    const end = Number(value) || 0;
    if (start === end) { setDisplay(end); refPrev.current = end; return; }
    let raf = null;
    const startTime = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3); // easeOutCubic
    const step = (now) => {
      const t = Math.min(1, (now - startTime) / duration);
      const v = Math.round(start + (end - start) * ease(t));
      setDisplay(v);
      if (t < 1) raf = requestAnimationFrame(step); else refPrev.current = end;
    };
    raf = requestAnimationFrame(step);
    return () => { if (raf) cancelAnimationFrame(raf); };
  }, [value, duration]);

  return <div className="count-anim">{display}</div>;
}

function Card({ title, value, color = '#333', icon, onClick }) {
  return (
    <div className="card card-summary" style={{ background: color, color: '#fff', cursor: onClick ? 'pointer' : 'default', padding: 12 }}>
      <div className="card-summary-inner" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className="icon-circle" aria-hidden style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
        <div className="card-summary-text">
          <div className="card-summary-title" style={{ fontSize: 12, opacity: 0.95 }}>{title}</div>
          <div className="card-summary-value" style={{ fontSize: 20, fontWeight: 700 }}><CountAnim value={value} /></div>
        </div>
      </div>
    </div>
  );
}

function Panel({ title, children, hint }) {
  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <h4 style={{ margin: 0 }}>{title}</h4>
        {hint && <div className="muted" style={{ fontSize: 12 }}>{hint}</div>}
      </div>
      <div style={{ marginTop: 8 }}>{children}</div>
    </div>
  );
}
